import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['table'];
  isDown = false;
  startX;
  startY;
  scrollLeft;
  scrollTop;
  isHovering = false;

  connect() {
    console.log('list controller connected');
    if (this.hasTableTarget) {
      this.tableTarget.addEventListener('scroll', this.handleScroll.bind(this));
      this.tableTarget.addEventListener('mousedown', this.handleMouseDown.bind(this));
      this.tableTarget.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
      this.tableTarget.addEventListener('mouseup', this.handleMouseUp.bind(this));
      this.tableTarget.addEventListener('mousemove', this.handleMouseMove.bind(this));
      this.tableTarget.addEventListener('mouseenter', () => (this.isHovering = true));
      this.tableTarget.addEventListener('mouseleave', () => (this.isHovering = false));

      const scrollPositionH = this.tableTarget.dataset.listScrollPositionH;
      if (scrollPositionH) {
        this.tableTarget.scrollLeft = parseInt(scrollPositionH);
      }
    }
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
  }

  handleScroll(event) {
    // Record the horizontal scroll position
    this.scrollPositionH = event.target.scrollLeft;
    this.scrollPositionV = event.target.scrollTop;

    // Cache the rows for use in both conditions
    const rows = this.tableTarget.querySelectorAll('tr');

    if (this.scrollPositionH > 10) {
      console.log('scrolled > 10');
      rows.forEach((tr) => {
        const firstTd = tr.querySelector('td');
        if (firstTd) {
          firstTd.classList.add('scrolled-td');
        }
      });
    } else if (this.scrollPositionH < 10) {
      rows.forEach((tr) => {
        const firstTd = tr.querySelector('td');
        if (firstTd) {
          firstTd.classList.remove('scrolled-td');
        }
      });
    }
  }

  handleMouseDown(event) {
    // Check if the cmd or ctrl key is pressed
    if (!event.metaKey && !event.ctrlKey) return;

    this.isDown = true;
    this.startX = event.pageX - this.tableTarget.offsetLeft;
    this.startY = event.pageY - this.tableTarget.offsetTop;
    this.scrollLeft = this.tableTarget.scrollLeft;
    this.scrollTop = this.tableTarget.scrollTop;
  }

  handleKeyDown(event) {
    console.log('keydown');
    // Check for the presence of the dropdown in the DOM and if it's visible
    const dropdown = document.getElementById('search-dropdown-content');

    if (!this.isHovering || dropdown) return;

    const ARROW_UP = 38;
    const ARROW_DOWN = 40;
    const ARROW_LEFT = 37;
    const ARROW_RIGHT = 39;
    const SCROLL_AMOUNT = 40; // adjust as needed

    switch (event.keyCode) {
      case ARROW_UP:
        this.tableTarget.scrollTop -= SCROLL_AMOUNT;
        event.preventDefault();
        break;
      case ARROW_DOWN:
        this.tableTarget.scrollTop += SCROLL_AMOUNT;
        event.preventDefault();
        break;
      case ARROW_LEFT:
        this.tableTarget.scrollLeft -= SCROLL_AMOUNT;
        event.preventDefault();
        break;
      case ARROW_RIGHT:
        this.tableTarget.scrollLeft += SCROLL_AMOUNT;
        event.preventDefault();
        break;
      default:
        break;
    }
  }

  handleMouseLeave() {
    this.isDown = false;
  }

  handleMouseUp() {
    this.isDown = false;
  }

  handleMouseMove(event) {
    if (!this.isDown) return;
    event.preventDefault();
    const x = event.pageX - this.tableTarget.offsetLeft;
    const y = event.pageY - this.tableTarget.offsetTop;
    const walkH = x - this.startX;
    const walkV = y - this.startY;
    this.tableTarget.scrollLeft = this.scrollLeft - walkH;
    this.tableTarget.scrollTop = this.scrollTop - walkV;
  }

  addScrollParam(event) {
    console.log('scroll param');
    // Fetch the horizontal and vertical scroll positions
    const scrollPositionH = this.scrollPositionH;
    const scrollPositionV = this.scrollPositionV;

    // Update the button's parameters with the scroll positions
    const form = event.target.closest('form');
    if (form) {
      const inputH = document.createElement('input');
      inputH.type = 'hidden';
      inputH.name = 'scroll_position_h';
      inputH.value = scrollPositionH;
      form.appendChild(inputH);

      const inputV = document.createElement('input');
      inputV.type = 'hidden';
      inputV.name = 'scroll_position_v';
      inputV.value = scrollPositionV;
      form.appendChild(inputV);
    }
  }
}
